import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearBatch, addPushContentVariables } from "state/reducers/communicationBatching";
import { useHistory } from "react-router";
import { useCommsBatching } from "utils";
import MarketingNavigation from "./utils/components/MarketingNavigation";
import MarketingStepper from "./utils/components/MarketingStepper";
import MarketingButtons from "./utils/components/MarketingButtons";
import PushChatBubble from "./utils/components/push/PushChatBubble";
import MarketingContainer from "./utils/components/MarketingContainer";
import "./utils/styles/marketing-dashboard.css";

const BatchPush = () => {
  const [error, setError] = useState(false);
  const { getNextLink, getPreviousLink } = useCommsBatching({ currentPage: 'push' });
  const dispatch = useDispatch();
  const history = useHistory();
  const handleDiscardChanges = () => {
    dispatch(clearBatch());
    history.push("/v2-marketing");
  };

  const {
    pushContent,
    pushContentHeader,
    batchId,
  } = useSelector((state) => state.communicationBatching);

  if (!batchId) {
    dispatch(clearBatch());
    history.push('/v2-marketing');
  }

  const parsePushVariables = () => {
    const matches = pushContent.match(/{{.*?}}/g) || [];
    const pushHeaderMatches = pushContentHeader.match(/{{.*?}}/g) || [];
    const variables = matches.map((str) => str.substring(2, str.length - 2));
    const pushHeaderVariables = pushHeaderMatches.map((str) => str.substring(2, str.length - 2));
    dispatch(addPushContentVariables([...variables, ...pushHeaderVariables]));
  };

  return (
    <MarketingContainer>
      <MarketingNavigation/>
      <MarketingStepper />
      <MarketingButtons
        discardButton="Discard"
        discardChanges={handleDiscardChanges}
        prevButton="Previous"
        prevLink={getPreviousLink()}
        nextButton="Continue"
        nextLink={getNextLink()}
        onNext={parsePushVariables}
        spaceBetween
        // add back
        // required={
        //   !(message && message.length && message.trim().length) ||
        //     !(header && header.length && header.trim().length) ||
        //     !(batchName && batchName.length && batchName.trim().length)
        // }
      />
      <div className="flex flex-col justify-center mx-auto my-auto bg-transparent rounded-lg">
        <PushChatBubble enabled setError={setError} error={error} />
      </div>

    </MarketingContainer>
  );
};

export default BatchPush;
